export const UTS_ELIGIBLE_SHIPPING_PATTERNS = [/freight included/i, /free shipping/i]

export function isUtsEligibleShipping (option) {
  const desc = option?.description || ''
  return UTS_ELIGIBLE_SHIPPING_PATTERNS.some(re => re.test(desc))
}

export const EMPTY_UTS_FIELDS = {
  utsCarrierName: '',
  utsCarrierScac: '',
  utsServiceLevel: '',
  utsEstimateNumber: '',
  utsTransitDays: null,
  utsRateAmount: null
}

export function carrierToUtsFormFields (carrier, estimateNumber = '') {
  if (!carrier) return { ...EMPTY_UTS_FIELDS }
  return {
    utsCarrierName: carrier.carrierName || '',
    utsCarrierScac: carrier.utsScac || carrier.nationalScac || '',
    utsServiceLevel: carrier.serviceLevel || '',
    utsEstimateNumber: estimateNumber || '',
    utsTransitDays: carrier.transitDays ?? null,
    utsRateAmount: carrier.charges?.totalAmount != null ? Number(carrier.charges.totalAmount) : null
  }
}
